const $$splitErrorComponentImporter = () => import('/app/apps/webapp/src/app/routes/_authenticated/tracking/workouts/history.tsx?tsr-split=errorComponent');
const $$splitComponentImporter = () => import('/app/apps/webapp/src/app/routes/_authenticated/tracking/workouts/history.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { rethrowUnlessUnauthorized } from '@/app/lib/redirect-to-login';
import { defaultWorkoutDateRange } from '@/features/workouts/lib/date-range';
import { getCompletedWorkoutSeriesQuery } from '@/features/workouts/lib/get-completed-workout-series.query';
import { WorkoutsSkeleton } from '@/features/workouts/ui/workouts-skeleton';
export const Route = createFileRoute('/_authenticated/tracking/workouts/history')({
  loader: async ({
    context,
    location
  }) => {
    const range = defaultWorkoutDateRange();
    const deps = {
      controllers: {
        workoutController: context.deps.controllers.workoutController
      }
    };
    try {
      await context.queryClient.ensureQueryData(getCompletedWorkoutSeriesQuery(deps, range));
    } catch (error) {
      await rethrowUnlessUnauthorized(error, context.queryClient, `${location.pathname}${location.searchStr}`);
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent'),
  pendingComponent: WorkoutsSkeleton
});